angular
	.module 'App.Repository'
	.factory 'ShippingMethodRepository', ['BaseRepository', (BaseRepository) ->
		class ShippingMethodRepository extends BaseRepository
			@resource = '/shipping_methods'
			@isRestricted = true

		return new ShippingMethodRepository
	]
